import { render, staticRenderFns } from "./offer-custom-button.vue?vue&type=template&id=63425fde&"
import script from "./offer-custom-button.vue?vue&type=script&lang=js&"
export * from "./offer-custom-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports